export const slugIsValid = (slug) => {
  return slug
       && slug.match(/^[a-zA-Z0-9_\-]{3,}$/)
       && !slug.match(/^[0-9]+$/);
};

export default slugIsValid;
